module.exports = __webpack_public_path__ + "static/media/Biomedics.8cf7fb3d.jpg";